// extracted by mini-css-extract-plugin
module.exports = {"news":"index-module--news--yUnnP"};